<template>
  <div class="point-group-list">
    <template v-for="(group, index) in groupList">
      <PointGroup
        ref="pointGroups"
        :key="group.id"
        :group="group"
        :locationGroupType="group.locationType"
        :length="groupList.length"
        :index="index"
        :is-target-group="targetGroup.id === group.id"
        :has-edit-permission="hasEditPermission"
        :geocoder="geocoder"
      />
    </template>
  </div>
</template>

<script>
import ScrollMagic from 'scrollmagic'

import { getters } from '@/vuex/modules/pointGroupOperation/constants'
import PointGroup from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/PointGroup'
import { locationGroupType } from '../constants'

export default {
  name: 'PointGroupList',
  components: {
    PointGroup,
  },
  props: {
    groupList: {
      type: Array,
      default: () => [],
    },
    locationGroupType: {
      type: String,
      default: locationGroupType.CUSTOM_LOCATION,
    },
    hasEditPermission: {
      type: Boolean,
      default: false,
    },
    geocoder: {
      type: Function,
      required: true,
    },
    isCategoryGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      controller: null, // ScrollMagicController
    }
  },
  computed: {
    targetGroup() {
      return this.$store.getters[getters.targetGroup]
    },
  },
  watch: {
    targetGroup(newTargetGroup) {
      this.destroyScrollMagic()
      if (newTargetGroup.id === null) {
        this.$emit('targetGroupType', null)
        return
      }
      if (this.locationGroupType !== this.targetGroup.locationType) {
        return
      }

      this.$nextTick(() => {
        const index = this.groupList.findIndex(
          group => newTargetGroup.id === group.id,
        )
        const targetGroupElement = this.$refs.pointGroups[index].$el
        this.$emit('targetGroupType', this.locationGroupType)
        this.initScrollMagic(targetGroupElement)
      })
    },
  },
  beforeDestroy() {
    this.destroyScrollMagic()
  },
  methods: {
    initScrollMagic(el) {
      this.controller = new ScrollMagic.Controller()
      const offset = el.parentElement.getBoundingClientRect().top
      const scene = new ScrollMagic.Scene({
        triggerElement: el.children[0],
        triggerHook: 0,
        offset: -offset,
      }).setPin(el.children[0])

      this.controller.addScene(scene)
    },
    destroyScrollMagic() {
      if (this.controller) {
        this.controller.destroy(true)
        this.controller = null
      }
    },
  },
}
</script>

<style scoped>
.point-group-list {
  overflow-y: scroll;
  height: 94%;
  border-top: gray 1px solid;
  -ms-overflow-style: none; /* IE, Edge 対応 */
  scrollbar-width: none;
}
.point-group-list::-webkit-scrollbar {
  /* Chrome, Safari 対応 */
  display: none;
}
</style>
